import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/auth";
import React from 'react'
import Loading from "./Loading";
import { DEFAULT_ROUTES } from "../constants/constants";

const RequireAuth = ({ allowedRoles }) => {
    const { user, isLoading } = useAuth({ middleware: 'guest' });
    const location = useLocation()

    if (isLoading) return <Loading />
    const roles = [user?.role]

    return (
       roles?.find(role => allowedRoles?.includes(role)) ? <Outlet /> :
        user ? <Navigate to={`${DEFAULT_ROUTES[user?.role]}`} state={{ from: location }} replace />
            : <Navigate to="/login" state={{ from: location }} replace />
    )
}

export default RequireAuth;
